import setPieveSessionCompanyId from '@/lib/auth/setPieveSessionCompanyId.js';
import { getPieveAuthMe } from '@/redux/requests/authRequests.js';
import { getPieveUserCompanies } from '@/redux/requests/companiesRequests.js';
import { getPrefs } from '@/redux/requests/prefsRequests.js';
import { getAuthSession } from '@/redux/requests/sessionRequests.js';

const setStatus = (status, message = null) => ({ type: 'SESSION_CONTEXT_STATUS', payload: { status, message } });

/**
 * Loads what every signed-in screen needs once a session exists: the person's organizations, the
 * organization requests run in (the session's saved one when it is still theirs), their role and
 * permissions there, and their preferences. Sign-in, reset and invite answers carry only the user id,
 * so the session (name, email, saved organization) is read first when the store does not have it.
 */
const loadSignedInContext = ({ companyId = null } = {}) => {
  return async (dispatch, getState) => {
    dispatch(setStatus('loading'));
    let sessionCompanyId = companyId;

    if (!getState()?.user?.session?.user?.email) {
      const session = await getAuthSession();
      sessionCompanyId = sessionCompanyId || session?.companyId || null;
    }

    const companiesRes = await getPieveUserCompanies();
    const companies = Array.isArray(companiesRes?.companies) ? companiesRes.companies : [];

    if (companiesRes?.success === false || companies.length === 0) {
      dispatch(setStatus('error', companiesRes?.message || 'Your organizations could not be loaded.'));
      return { success: false };
    }

    const savedCompany = companies.find((company) => company?.id === sessionCompanyId);
    const activeCompanyId = savedCompany?.id || companiesRes?.ownPersonalCompanyId || companies[0].id;

    setPieveSessionCompanyId(activeCompanyId);
    dispatch({ type: 'SET_PIEVE_SESSION_COMPANY_ID', payload: activeCompanyId });

    const [authRes, prefsRes] = await Promise.all([getPieveAuthMe({ companyId: activeCompanyId }), getPrefs()]);

    if (authRes?.success === false || prefsRes?.success === false) {
      dispatch(setStatus('error', authRes?.message || prefsRes?.message || 'Your account could not be loaded.'));
      return { success: false };
    }

    dispatch(setStatus('ready'));
    return { success: true, data: { companyId: activeCompanyId } };
  };
};

export default loadSignedInContext;
